module.exports = {"130272101":"汉沽管理区汉丰镇","130272451":"汉沽管理区兴农","130272452":"汉沽管理区振兴街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130272.json
// module id = 94
// module chunks = 0